<template>
  <el-dialog
    :title="$t('text.update_patient')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :lock-scroll="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="closeDialog()"
    width="1000px"
    class="edit-patient"
    v-if="dialogVisible"
  >
    <div>
      <div class="step-wrapper">
        <el-steps
          :active="activeCard"
          finish-status="success"
          simple
          class="update-patient-step"
          :class="selectedPatient ? 'clickable-step' : ''"
        >
          <el-step
            :title="$t('text.select_a_patient')"
            icon="el-icon-user"
            @click.native="goTab(0)"
            :class="activeCard === 0 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="$t('text.details')"
            icon="el-icon-info"
            :status="selectedPatient ? 'process' : ''"
            :class="activeCard === 1 ? 'active-step' : ''"
            @click.native="goTab(1)"
          ></el-step>
          <el-step
            :title="$t('text.facility_setup')"
            icon="el-icon-office-building"
            :status="selectedPatient ? 'process' : ''"
            :class="activeCard === 2 ? 'active-step' : ''"
            @click.native="goTab(2)"
          ></el-step>
          <el-step
            :title="$t('text.Devices')"
            icon="el-icon-box"
            :status="selectedPatient ? 'process' : ''"
            :class="activeCard === 3 ? 'active-step' : ''"
            @click.native="goTab(3)"
          ></el-step>
          <el-step
            :title="$t('text.products')"
            icon="el-icon-help"
            :status="selectedPatient ? 'process' : ''"
            :class="activeCard === 4 ? 'active-step' : ''"
            @click.native="goTab(4)"
          ></el-step>
        </el-steps>
      </div>
      <SelectPatient
        ref="selectPatient"
        @patientChange="patientChange"
        v-show="activeCard === 0"
      />
      <PatientDetailSection
        ref="patientDetailSection"
        v-show="activeCard === 1"
      />
      <PatientBuildingSection
        ref="patientBuildingSection"
        v-show="activeCard === 2"
      />
      <PatientDeviceSection
        ref="patientDeviceSection"
        v-show="activeCard === 3"
      />
      <PatientProductsSection
        ref="patientProductsSection"
        v-show="activeCard === 4"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="next()"
        v-if="activeCard === 0"
        >{{ $t('text.continue').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="saveLoading"
        v-else
        >{{ $t('text.update').toUpperCase() }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import PatientDetailSection from '@/components/manage/patients/editPatient/PatientDetailSection.vue'
import PatientBuildingSection from '@/components/manage/patients/editPatient/PatientBuildingSection.vue'
import PatientDeviceSection from '@/components/manage/patients/editPatient/PatientDeviceSection.vue'
import PatientProductsSection from '@/components/manage/patients/editPatient/PatientProductsSection.vue'
import SelectPatient from '@/components/patients/quickActions/SelectPatient.vue'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      activeCard: 0,
      saveLoading: false,
      selectedPatient: ''
    }
  },
  components: {
    PatientDetailSection,
    PatientBuildingSection,
    PatientDeviceSection,
    PatientProductsSection,
    SelectPatient
  },
  methods: {
    patientChange(e) {
      this.selectedPatient = e
      if (!e) return
      this.$refs.patientDetailSection.form = this.selectedPatient
      this.$refs.patientBuildingSection.form = this.selectedPatient
      this.$refs.patientDeviceSection.form = this.selectedPatient
      this.$refs.patientProductsSection.form = this.selectedPatient
      if (this.selectedPatient) {
        this.activeCard++
      }
    },
    goTab(index) {
      if (!this.selectedPatient) return false
      this.activeCard = index
    },
    next() {
      let valid = false
      this.$refs.selectPatient.$refs.form.validate(res => {
        valid = res
      })
      if (valid) {
        this.activeCard++
      }
    },
    back() {
      this.activeCard--
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs.selectPatient.$refs.form.resetFields()
      this.$refs.patientDetailSection.$refs.form.resetFields()
      this.$refs.patientBuildingSection.$refs.form.resetFields()
      this.$refs.patientDeviceSection.$refs.form.resetFields()
      this.$refs.patientProductsSection.$refs.form.resetFields()
      this.activeCard = 0
      this.dialogVisible = false
    },
    submit() {
      let detailValid = false
      let buildingValid = false
      let deviceValid = false
      let productValid = false
      this.$refs.patientDetailSection.$refs.form.validate(valid => {
        detailValid = valid
      })
      this.$refs.patientBuildingSection.$refs.form.validate(valid => {
        buildingValid = valid
      })
      this.$refs.patientDeviceSection.$refs.form.validate(valid => {
        deviceValid = valid
      })
      this.$refs.patientProductsSection.$refs.form.validate(valid => {
        // User should be able to use just day product or night product. Both are not necessary
        let dayProduct = this.$refs.patientProductsSection.form.DayProductId
        let nightProduct = this.$refs.patientProductsSection.form.NightProductId

        let dayProductValid = dayProduct && dayProduct > 0
        let nightProductValid = nightProduct && nightProduct > 0
        productValid = valid && (dayProductValid || nightProductValid)
        if (!dayProductValid && !nightProductValid) {
          swal({
            icon: 'warning',
            title: 'Warning',
            text: this.$t('text.please_select_one_product')
          })
        }
      })
      if (!detailValid) {
        this.activeCard = 1
      } else if (!buildingValid) {
        this.activeCard = 2
      } else if (!deviceValid) {
        this.activeCard = 3
      } else if (!productValid) {
        this.activeCard = 4
      }
      if (detailValid && buildingValid && deviceValid && productValid) {
        this.save()
      }
    },
    save() {
      let patient = {
        ...this.$refs.patientDetailSection.form,
        ...this.$refs.patientBuildingSection.form,
        ...this.$refs.patientDeviceSection.form,
        ...this.$refs.patientProductsSection.form,
        ...this.selectedPatient
      }
      this.saveLoading = true
      this.$store
        .dispatch('patient/savePatient', patient)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.closeDialog()
            this.$router.push({
              path: '/dashboard',
              query: { hightLightPatientId: response.data.data.PatientId }
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>
